import { ContentFlexComponent } from "components/flexComponents/Content/typings";
import * as React from "react";
import EditorialBase from "components/flexComponents/Content/factory/EditorialBase";
import { EditorialModel, Media } from "typings/microserviceModels/content-flex-module";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { ImageEditorialWithLink } from "./ImageEditorialWithLink";
import { UitkImage } from "uitk-react-images";

export class MultipleImages extends EditorialBase {
  /* istanbul ignore next */
  public constructor(editorial: ContentFlexComponent) {
    super(editorial);
  }

  private generateImageComponents = (items: EditorialModel[]) =>
    items
      .filter((item: EditorialModel) => item.media && item.media.filter((media) => media.mediaUrl))
      .map((item: EditorialModel) => item.media)
      .reduce((item, acum) => acum && acum.concat.apply(acum, item), [])
      .sort((a: Media, b: Media) => a.mediaSeq - b.mediaSeq)
      .map(({ mediaUrl, mediaAlt, clickUrl }: Media) => (
        <UitkLayoutFlexItem key={mediaUrl}>
          <div>
            {clickUrl ? (
              <ImageEditorialWithLink key={mediaUrl} mediaUrl={mediaUrl} mediaAlt={mediaAlt} clickUrl={clickUrl} />
            ) : (
              <div className="all-y-padding-two">
                <UitkImage key={mediaUrl} alt={mediaAlt} src={mediaUrl} className="images-size" />
              </div>
            )}
          </div>
        </UitkLayoutFlexItem>
      ));

  /**
   * An Editorial consists of HTML strings that we parse through with the best of
   * our abilities and display as is on the page. Mainly, we do not control the
   * content of an Editorial, we simply put them in the page.
   */
  public generate() {
    return (
      <UitkLayoutFlex
        id={this.flexComponent.id}
        data-fm={this.flexComponent.fmId}
        data-fm-title-id={this.flexComponent.fmTitleId}
        direction="column"
        className="editorial-images-flex-container all-t-padding-six"
      >
        <UitkLayoutFlexItem className="uitk-type-center uitk-type-paragraph-200">
          <div>{this.editorial.items.map((item) => item.title)}</div>
        </UitkLayoutFlexItem>
        <UitkLayoutFlex justifyContent="center">
          <UitkLayoutFlexItem>
            <div>
              <UitkLayoutFlex justifyContent="center" space="twelve">
                {this.generateImageComponents(this.editorial.items)}
              </UitkLayoutFlex>
            </div>
          </UitkLayoutFlexItem>
        </UitkLayoutFlex>
      </UitkLayoutFlex>
    );
  }
}

export default MultipleImages;
